import React from 'react';
import ReactDOM from 'react-dom';

import '../assets/css/datepicker.css';
import '../vendors/datepicker.min.js';

var moment = require('moment');

//----------------------------------------------------------------------
//   DateChooser
//
//----------------------------------------------------------------------
export class DateChooser extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      dateValue: this.props.dateValue,
    };
    this.handleChange       = this.handleChange.bind(this);
    this.handleValidateDate = this.handleValidateDate.bind(this);
    this.handleFocus        = this.handleFocus.bind(this);
  }

  componentDidMount() {

      var self = this;            
                                                
      var dateInput = $('#'+this.props.id);
                                           
      $(dateInput).datepicker({            
          format: 'yyyy-mm-dd',
          zIndex: 100060,
          autoHide: true,
          offset: 5      
      });          
      $(dateInput).on('pick.datepicker', function (e) {
          var d = $(dateInput).datepicker('getDate', true);
          //console.log('on pick.datepicker date=', d );
          self.handleValidateDate(d);
          if (self.props.onChange) {
              setTimeout( function() {
                  self.props.onChange( d );
              }, 100);
          }
      });
      return;
  }

  handleChange(event) {

      if (this.props.onChange) {
          var newVal = event.target.value+'';
          var self = this;
          setTimeout( function() {
              self.props.onChange( newVal ); 
          }, 100);
      }  

      if (event.target.dataset.toggle === 'datepicker') {
        this.handleValidateDate(event.target.value);
      }

  }

  handleValidateDate(date) {
      if (this.props.onError) {
          this.props.onError(event);
      }

      console.log("handleValidateDate");

      if (moment(date, 'YYYY-MM-DD', true).isValid()) {
        $('#'+this.props.id + '_div').removeClass('has-error');
        $('#'+this.props.id).css("backgroundColor", "");
      } else {
        $('#'+this.props.id + '_div').addClass('has-error');
        $('#'+this.props.id).css('backgroundColor', '#f9d9d9');
      }

  }

  handleFocus(event) {
      if (this.props.onFocus) {
          this.props.onFocus(event);
      }
  }

  render() {

      if (this.state.dateValue && this.state.dateValue.length > 10) {
          // limit to date part                                      
          this.state.dateValue = this.state.dateValue.substring(0,10);
      }                                                               
       
      return (
      <div id={this.props.id + '_div'} className="form-group">
        <input type="text"
               className="form-control datepicker"
               data-toggle="datepicker"           
               id={this.props.id}      
               defaultValue={this.state.dateValue}
               placeholder={this.props.placeholder}
               onChange={this.handleChange}
               onFocus={this.handleFocus}
               style={this.props.style}                
         />
      </div>
      );   
  }     
};